import { ProfileEditFormSection } from '@containers';

function ProfileEdit() {
  return <ProfileEditFormSection />;
}

export default ProfileEdit;
